export default "dist/images/block-notification-plain.2867ecb.png";